module.exports = __webpack_public_path__ + "img/logo.f194fba7.png";